/* Barre d'achat collante : suit le prix du widget, apparaît quand le bouton principal sort de l'écran.
   Rien en global ; une seule barre par page (la première instance gagne). */
(function () {
  function setup(bar) {
    document.body.appendChild(bar);
    document.body.classList.add('has-sticky-atc');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');
    function widget() { return document.querySelector('.hh[data-hh], .pov2'); }
    function mainCta() { var w = widget(); return w ? w.querySelector('.hh__cta, .pov2-btn') : null; }
    function currentPrice() {
      var w = widget(); if (!w) return '';
      var el = w.querySelector('[data-now], .pov2-btn__price, [data-gift-total-price]');
      return el ? el.textContent.trim() : '';
    }
    var thenEl = bar.querySelector('[data-sticky-atc-then]');
    function currentThen() {
      var w = widget(); if (!w) return '';
      var el = w.querySelector('[data-then]');
      if (el) return el.innerHTML.trim();
      /* Widget CRO : segment actif de la carte abonnement (« Then £47.43/6 months ») ; rien en achat unique ni en prix par jour */
      var card = w.querySelector('.pov2-card--active');
      if (!card || card.getAttribute('data-mode') !== 'sub_only') return '';
      var seg = card.querySelector('[data-segs="sub"] .pov2-seg--active [data-seg-sub-6m-saving], [data-segs="sub"] .pov2-seg--active [data-seg-sub-1y-saving]');
      var t = seg ? seg.textContent.trim() : '';
      if (!t || !/\d/.test(t) || /\/\s*(day|jour|tag|d[ií]a|dag|dzie|giorno)/i.test(t)) return '';
      t = t.replace(/&/g, '&amp;').replace(/</g, '&lt;');
      return t.replace(/([£$€]\s?[\d.,]+|[\d.,]+\s?[£$€])/, '<b>$1</b>');
    }
    function syncThen() {
      if (!thenEl) return;
      var h = currentThen();
      if (h === thenEl.innerHTML) return;
      thenEl.innerHTML = h;
      thenEl.hidden = !h;
    }
    var bumpT = 0;
    function syncPrice() {
      var p = currentPrice(); if (!p || p === priceEl.textContent) return;
      var changed = priceEl.textContent.trim() !== '' && priceEl.textContent.trim() !== ' ';
      priceEl.textContent = p;
      if (changed) { priceEl.classList.add('is-bump'); clearTimeout(bumpT); bumpT = setTimeout(function () { priceEl.classList.remove('is-bump'); }, 900); }
    }
    bar.querySelector('[data-sticky-atc-cta]').addEventListener('click', function () {
      var t = widget() || document.querySelector('#shopify-section-main, [id*="shopify-section"][id*="main"]');
      if (!t) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
    });
    var observedCta = null, io = null;
    function show(v) { bar.setAttribute('data-show', v ? '1' : '0'); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); }
    function bind() {
      var cta = mainCta();
      if (!cta) { show(window.scrollY > 600); return; }
      if (cta === observedCta) return;
      if (io) io.disconnect();
      observedCta = cta;
      io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        show(!e.isIntersecting && window.scrollY > 200);
      }, { threshold: 0 });
      io.observe(cta);
    }
    function tick() { bind(); syncPrice(); syncThen(); }
    tick();
    window.addEventListener('scroll', function () { if (!observedCta) bind(); }, { passive: true });
    if (window.MutationObserver) { new MutationObserver(function () { tick(); }).observe(document.body, { childList: true, subtree: true, characterData: true }); }
  }
  function boot() {
    var bars = document.querySelectorAll('[data-sticky-atc]:not([data-ready])');
    if (!bars.length) return;
    bars[0].setAttribute('data-ready', '');
    setup(bars[0]);
    for (var i = 1; i < bars.length; i++) bars[i].remove();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
